<lib-form-field-container
    [kind]="kindOverride"
    [hideErrors]="hideErrors">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>
    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>
    <ng-content
        menu
        select="[menu]"></ng-content>

    <ng-container prefixIcon>
        <lib-icon-button
            [icon]="Icon.Common.Search"
            [kind]="ButtonKind.FormField"
            [disabled]="isDisabled"
            [size]="ButtonSize.Large"
            matTooltip="Search"
            i18n-matTooltip="@@CommonSearchLabel"
            (clicked)="SearchIconClicked()"></lib-icon-button>
    </ng-container>

    @if (formControl.value) {
        <ng-container suffixIcon>
            <lib-icon-button
                [icon]="Icon.Common.Close"
                [kind]="ButtonKind.FormField"
                [size]="ButtonSize.Large"
                [disabled]="isDisabled"
                matTooltip="Clear"
                i18n-matTooltip="@@CommonClearLabel"
                (clicked)="ClearIconClicked()"></lib-icon-button>
        </ng-container>
    }

    <input
        #input
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                        [attr.aria-label]="ariaLabel || null"
                        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        [formControl]="viewControl"
        [attr.autocorrect]="autocorrect ? 'on' : 'off'"
        [autocomplete]="autocorrect ? 'on' : 'off'"
        [spellcheck]="autocorrect"
        [placeholder]="placeholderText"
        [maxLength]="maxCharacterLength"
        [attr.data-sb-qa]="qaTag"
        (blur)="OnBlur()"
        (change)="$event.stopPropagation()" />
</lib-form-field-container>
